import { IConfirmInitialState } from "./types";

const initialState: IConfirmInitialState = {
  open: false,
};

export default initialState;